module.exports = __webpack_public_path__ + "static/img/bg_light.d283ea9.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/bg_light.png
// module id = Sqxy
// module chunks = 1